export default defineNuxtPlugin({
  name: "sentry",
  async setup(nuxtApp) {
    const vueApp = nuxtApp.vueApp;
    const config = useRuntimeConfig();

    if (import.meta.client && config.public.SENTRY_DSN_PUBLIC) {
      const Sentry = await import("@sentry/vue");
      const { browserTracingIntegration, replayIntegration } = Sentry;

      Sentry.init({
        app: vueApp,
        dsn: config.public.SENTRY_DSN_PUBLIC,
        integrations: [
          browserTracingIntegration({ router: useRouter() }),
          replayIntegration()
        ],
        tracesSampleRate: config.public.SENTRY_TRACES_SAMPLE_RATE,
        replaysSessionSampleRate: config.public.SENTRY_REPLAY_SAMPLE_RATE,
        replaysOnErrorSampleRate: config.public.SENTRY_ERROR_REPLAY_SAMPLE_RATE,
      });
    }
  },
});